import { OrdersPerCategoryChartDto } from "../../domain";
import { JObject } from "../../../../common/data/models";

export const OrdersPerCategoryChartMapper = {

    fromJson(json?: JObject): OrdersPerCategoryChartDto {

        var colors = ["#FFA726", "#42A5F5", "#c41f46", "#85293f", "#a31d1d", "#ed5a5a", "#f56f42", "#edddd8",
            "#9c8983", "#5e2412", "#2295c7", "#3b677a", "#6b1a62", "#bf5cb4", "#360730", "#6e586b"];
        if (!json) {
            return {
                label: [],
                values: [],
                datasets:[],
                xlsxReportURI: ""
            }
        }
        var finalResult: OrdersPerCategoryChartDto = {
            label: [],
            values: [],
            datasets:[],
            xlsxReportURI: json.xlsxReportURI
        };
        finalResult.values= json.values.map((e:JObject)=>{
            return {
                category: e.label,
                store: e.label2,
                value: e.value,
            }
        });
        var stores:string[] = json.values.map((e:JObject) => {
            return e.label2
        });
        stores = stores.filter((item, index) => stores.indexOf(item) === index);
        finalResult.label = stores;
        var categories:string[] = json.values.map((e:JObject) => {
            return e.label;
        });
        categories = categories.filter((item, index) => categories.indexOf(item) === index);
        var i = 0;
        for (const categorty of categories) {

            var values: number[] = [];
            for (const store of stores) {
                if (json.values.filter((x:JObject) => x.label === categorty && x.label2 === store).length > 0)
                    values.push(json.values.filter((x:JObject) => x.label === categorty && x.label2 === store).at(0)!.value)
                else
                    values.push(0);
            }
            finalResult.datasets.push({
                color: colors.at(i)!,
                name: categorty,
                values: values
            });
            i += 1;
        }
        return finalResult;
    }
}
